<template>
  <div class="apply">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'业务申请'}]"></breadcrumb>
    <div class="apply-wrap">
      <div class="apply-contain">
        <page-title title="业务申请">
          <div>
            <span style="font-weight:500">审核状态</span>
            <el-select style="width:90px; margin-right:25px;margin-left:15px;"
                       @change="getList()"
                       v-model="params.status"
                       clearable>
              <el-option label="待审批"
                         :value="0"></el-option>
              <el-option label="已通过"
                         :value="1"></el-option>
              <el-option label="已驳回"
                         :value="2"></el-option>
              <el-option label="已读"
                         :value="3"></el-option>
              <el-option label="已批示"
                         :value="4"></el-option>
            </el-select>
            <el-input style="width:140px;margin-right:15px;"
                      clearable
                      v-model="params.name"
                      @keyup.enter.native="getList()"
                      placeholder="请输入"></el-input>
            <el-dropdown @command="showDialog">
              <el-button type="primary">
                业务申请
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in templateList"
                                  :command="index"
                                  :key="item.id">{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </page-title>
        <div class="apply-table-wrap">
          <div class="apply-table">
            <table>
              <tr v-for="item in applyList"
                  :key="item.id">
                <td @click="showDetail(item.id)">{{item.name}}</td>
                <td style="text-align:center">
                  <div v-if="item.status===0"
                       style="color:#9B9B9B">
                    <font-awesome-icon style="margin-right:6px;  cursor:pointer"
                                       :icon="['fas', 'exclamation-circle']" />待审批
                  </div>
                  <div v-else-if="item.status===1"
                       style="color:#39B54A">
                    <font-awesome-icon style="margin-right:6px;  cursor:pointer"
                                       :icon="['fas', 'check-circle']" />已通过
                  </div>
                  <div v-else-if="item.status===2"
                       style="color:#F56C6C">
                    <font-awesome-icon style="margin-right:6px;  cursor:pointer"
                                       :icon="['fas', 'times-circle']" />已驳回
                  </div>
                  <div v-else-if="item.status===3"
                       style="color:#39B54A">
                    <font-awesome-icon style="margin-right:6px;  cursor:pointer"
                                       :icon="['fas', 'check-circle']" />已读
                  </div>
                  <div v-else-if="item.status===4"
                       style="color:#39B54A">
                    <font-awesome-icon style="margin-right:6px;  cursor:pointer"
                                       :icon="['fas', 'check-circle']" />已批示
                  </div>
                </td>
                <td style="text-align:center">{{item.createTime.replace('T',' ')}}</td>
                <td style="text-align:right;width:90px;color:#e97e00"><a style="color:#e97e00" v-if="item.fileUrlFinal" :href="item.fileUrlFinal"  :download="item.fileUrlFinal">归档文档下载</a></td>
                 <td style="text-align:right; width:90px; padding-left:0px;color:#e97e00"><a style="color:#e97e00" v-if="item.fileUrlOriginal"  :href="item.fileUrlOriginal"  :download="item.fileUrlOriginal" >原始文档下载</a></td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="params.current"
                         class="apply-pagination"
                         background
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <!--请假申请表详情-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template6"
               :modal="formShow===6"
               class="template_dialog"
               :style="{visibility:formShow===6?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/></div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">姓名</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">所属部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_gray">日常考勤申请</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">类型</div>
          <div class="template_dialog-item"
               v-if="templateContent.leaveType">{{templateContent.leaveType|leaveTypeFilter}}</div>
          <div class="template_dialog-item"
               v-else>-</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">请假日期</div>
          <div class="template_dialog-item">{{templateContent.startTime?(templateContent.startTime.split('T')[0] + ' 至 ' + templateContent.endTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_gray">休假申请</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">休假天数</div>
          <div class="template_dialog-item">{{templateContent.annualDays||'-'}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">尚余天数</div>
          <div class="template_dialog-item">{{templateContent.annualRemainDays||'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">休假时间</div>
          <div class="template_dialog-item">{{templateContent.annualStartLeaveTime?(templateContent.annualStartLeaveTime.split('T')[0]+ ' 至 ' + templateContent.annualEndLeaveTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_gray">休假期间工作安排</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--交际应酬申请表-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template1"
               :modal="formShow===1"
               class="template_dialog"
               :style="{visibility:formShow===1?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>交际应酬费申请表（本市或外埠）</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">职位</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">应酬日期</div>
          <div class="template_dialog-item">{{templateContent.yingchouTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">总人数</div>
          <div class="template_dialog-item">{{templateContent.pepleNum}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">应酬单位</div>
          <div class="template_dialog-item">{{templateContent.yingchouUnit}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">应酬地点</div>
          <div class="template_dialog-item">{{templateContent.yingchouPlace}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">预计金额</div>
          <div class="template_dialog-item">{{templateContent.money}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">应酬目的</div>
          <div class="template_dialog-item left">{{templateContent.yingchouPurpose}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">活动内容</div>
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">嘉宾姓名</div>
          <div class="template_dialog-item">嘉宾职务</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">内陪人员姓名</div>
          <div class="template_dialog-item">职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.activities"
              :key="'1'+index">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">{{item.name}}</div>
          <div class="template_dialog-item">{{item.duty}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">{{item.neipei}}</div>
          <div class="template_dialog-item">{{item.neipeiDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--办公用品领用表-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template2"
               :modal="formShow===2"
               class="template_dialog"
               :style="{visibility:formShow===2?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>办公用品领用表</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">办公室用品名称</div>
          <div class="template_dialog-item">规格</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">成本归属</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.officeSupplies"
              :key="'2'+index">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">{{item.name}}</div>
          <div class="template_dialog-item">{{item.specification}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.costCenter}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--外购礼品申请表-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template4"
               :modal="formShow===4"
               class="template_dialog"
               :style="{visibility:formShow===4?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>外购礼品申请表</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">预算</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.giftList"
              :key="'4' +index">
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item">{{item.giftName}}</div>
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.money}}</div>
          <div class="template_dialog-item">{{item.guestName}}</div>
          <div class="template_dialog-item">{{item.guestCompany}}</div>
          <div class="template_dialog-item">{{item.guestDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--自制礼品申请表-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template5"
               :modal="formShow===5"
               class="template_dialog"
               :style="{visibility:formShow===5?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>自制礼品领用表</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">单价</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.giftList"
              :key="'5' +index">
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item">{{item.giftName}}</div>
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.money}}</div>
          <div class="template_dialog-item">{{item.guestName}}</div>
          <div class="template_dialog-item">{{item.guestCompany}}</div>
          <div class="template_dialog-item">{{item.guestDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--名片申请表-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template3"
               :modal="formShow===3"
               class="template_dialog"
               :style="{visibility:formShow===3?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>名片申请表</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">申请数量</div>
          <div class="template_dialog-item">{{templateContent.count}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_gray">名片资料</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">姓名</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">职位</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">部门</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.chineseName}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishName}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishDutyName}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishDepartmentName}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">直线电话</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">总机及分机电话</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">传真</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.telephone}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.zongji}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.fax}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">手机</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">E-mail</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">网址</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.phone}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.email}}</div>
        </div>
        <div class="template_col"
             style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.website}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">备注</div>
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">申请日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList"
              :key="item.id">
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">{{item.name}}</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <img v-if="signList.length>index+1"
                 :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title"
               :class="{last:detail.nodeUserIdsList.length-1===index}">签署日期</div>
          <div class="template_dialog-item"
               :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--出差报告-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template7"
               :modal="formShow===7"
               class="template_dialog"
               :style="{visibility:formShow===7?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>出差报告</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">出差日期</div>
          <div class="template_dialog-item">{{templateContent.startTime?(templateContent.startTime.split('T')[0] + ' 至 ' + templateContent.endTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_title">出差地点</div>
          <div class="template_dialog-item">{{templateContent.place}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">出差期间主要拜访人员</div>
          <div class="template_dialog-item">{{templateContent.seePeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">工作内容及工作成效</div>
          <div class="template_dialog-item">{{templateContent.content}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">下一步工作思路及拓展方向</div>
          <div class="template_dialog-item">{{templateContent.nextGoal}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">需要解决的问题、支持及建议</div>
          <div class="template_dialog-item last">{{templateContent.remark}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--工作周报-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template8"
               :modal="formShow===8"
               class="template_dialog"
               :style="{visibility:formShow===8?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>工作周报</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.time}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">凤凰卫视中文台、资讯台、电影台市场拓展</div>
          <div class="template_dialog-item">{{templateContent.fenghuangweishi}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">凤凰专区项目进展</div>
          <div class="template_dialog-item">{{templateContent.fenghuangzhuanqv}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">新业务拓展</div>
          <div class="template_dialog-item">{{templateContent.newTask}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">与凤凰其他部门的合作及支持</div>
          <div class="template_dialog-item">{{templateContent.hezuo}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">管理中心交办事物</div>
          <div class="template_dialog-item last">{{templateContent.center}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">行业动态及建议</div>
          <div class="template_dialog-item last">{{templateContent.suggest}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--呈批件-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template9"
               :modal="formShow===9"
               class="template_dialog"
               :style="{visibility:formShow===9?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>呈批件</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
                 :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div style="height:200px"
               class="template_dialog-item_input">
            <div class="template_dialog-item_text">批示：{{templateContent.pishi}}</div>
            <div class="template_dialog-item_sign">
              <span>签名：</span><img v-if="signList.length>=2"
                   :src="signList[1].signUrl"></div>
          </div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_input">题目：{{templateContent.topic}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div style="height:200px"
               class="template_dialog-item_input last">内容：{{templateContent.content}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--备忘录-->
    <el-dialog :close-on-click-modal="false" @close="formShow = ''"
               width="740px"
               id="template10"
               :modal="formShow===10"
               class="template_dialog"
               :style="{visibility:formShow===10?'visible':'hidden'}"
               :visible="true">
      <div class="template_dialog-title"
           slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>备忘录</div>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div class="template_dialog-item_img"
               :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}">
            <img v-if="signList.length"
            class="sign_img"
                 >
          </div>
        </div>
        <div class="template_col"
             style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div style="height:200px"
               class="template_dialog-item_input">
            <div class="template_dialog-item_text">批示：{{templateContent.pishi}}</div>
            <div class="template_dialog-item_sign">
              <span>签名：</span><img v-if="signList.length>=2"
                   :src="signList[1].signUrl"></div>
          </div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div class="template_dialog-item_input">题目：{{templateContent.topic}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col"
             style="width:100%">
          <div style="height:200px"
               class="template_dialog-item_input last">内容：{{templateContent.content}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--请假申请表表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="考勤申请"
               v-if="applyFormShow==6"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属部门">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>日常考勤申请</span>
          </div>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="类别">
              <el-select v-model="applyForm.templateContent.leaveType">
                <el-option label="病假"
                           :value="1"></el-option>
                <el-option label="事假"
                           :value="2"></el-option>
                <el-option label="产假/赔产假"
                           :value="3"></el-option>
                <el-option label="婚假"
                           :value="4"></el-option>
                <el-option label="丧假"
                           :value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假日期">
              <el-date-picker v-model="applyForm.templateContent.startTime"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>休假申请（年假）</span>
          </div>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="休假天数">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.annualDays"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="尚余天数">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.annualRemainDays"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="休假时间">
              <el-date-picker v-model="applyForm.templateContent.annualStartLeaveTime"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="休假期间工作安排">
              <el-input type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        v-model="applyForm.templateContent.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--交际应酬费申请表表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="交际应酬申请表"
               v-if="applyFormShow==1"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="申请人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker placeholder="选择日期"
                              v-model="applyForm.templateContent.createTime"
                              type="date"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="职位">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应酬日期">
              <el-date-picker v-model="applyForm.templateContent.yingchouTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="部门">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总人数">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.pepleNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="应酬单位">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.yingchouUnit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="应酬地点">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.yingchouPlace"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计金额">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.money"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="应酬目的">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.yingchouPurpose"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="活动内容">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>嘉宾列表</span>
          </div>
        </el-row>
        <el-row v-for="(item,index) in applyForm.templateContent.activities"
                :key="index"
                :gutter="15">
          <el-col :span="5">
            <el-form-item label="嘉宾姓名">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="嘉宾职务">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="内陪人员姓名">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.neipei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.neipeiDuty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div v-if="index===applyForm.templateContent.activities.length-1"
                 class="apply-icon">
              <span @click="delnode()">
                <font-awesome-icon style="color:#d0021b; margin-right:6px;  cursor:pointer"
                                   :icon="['fas', 'minus-circle']" />
              </span>
              <span @click="addnode()">
                <font-awesome-icon style="color:#39B54A; margin-right:10px; cursor:pointer"
                                   :icon="['fas', 'plus-circle']" />
              </span>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--办公室用品领用表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="办公室用品领用表"
               v-if="applyFormShow==2"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="申请人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker v-model="applyForm.templateContent.createTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>办公用品列表</span>
          </div>
        </el-row>
        <el-row v-for="(item,index) in applyForm.templateContent.officeSupplies"
                :key="index"
                :gutter="15">
          <el-col :span="5">
            <el-form-item label="办公用品名称">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规格">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.specification"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="数量">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.count"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="成本归属">
              <el-input clearable
                        placeholder="请输入"
                        v-model="item.costcCenter"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div v-if="index===applyForm.templateContent.officeSupplies.length-1"
                 class="apply-icon">
              <span @click="delnode()">
                <font-awesome-icon style="color:#d0021b; margin-right:6px;  cursor:pointer"
                                   :icon="['fas', 'minus-circle']" />
              </span>
              <span @click="addnode()">
                <font-awesome-icon style="color:#39B54A; margin-right:10px; cursor:pointer"
                                   :icon="['fas', 'plus-circle']" />
              </span>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--外购礼品申请表表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="外购礼品申请表"
               v-if="applyFormShow==4"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="申请人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker v-model="applyForm.templateContent.createTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>礼品列表</span>
          </div>
        </el-row>
        <div v-for="(item,index) in applyForm.templateContent.giftList"
             :key="index">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="礼品名称">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.giftName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="数量">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.count"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="预算">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.money"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="赠送嘉宾">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="11">
              <el-form-item label="嘉宾单位">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestCompany  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="嘉宾职务">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestDuty"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div v-if="index===applyForm.templateContent.giftList.length-1"
                   class="apply-icon">
                <span @click="delnode()">
                  <font-awesome-icon style="color:#d0021b; margin-right:6px;  cursor:pointer"
                                     :icon="['fas', 'minus-circle']" />
                </span>
                <span @click="addnode()">
                  <font-awesome-icon style="color:#39B54A; margin-right:10px; cursor:pointer"
                                     :icon="['fas', 'plus-circle']" />
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--自制礼品申请表表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="自制礼品领用表"
               v-if="applyFormShow==5"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="申请人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker v-model="applyForm.templateContent.createTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="apply-dialog_title">
            <span>礼品列表</span>
          </div>
        </el-row>
        <div v-for="(item,index) in applyForm.templateContent.giftList"
             :key="index">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="礼品名称">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.giftName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="数量">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.count"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="单价">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.money"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="赠送嘉宾">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="11">
              <el-form-item label="嘉宾单位">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestCompany  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="嘉宾职务">
                <el-input clearable
                          placeholder="请输入"
                          v-model="item.guestDuty"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div v-if="index===applyForm.templateContent.giftList.length-1"
                   class="apply-icon">
                <span @click="delnode()">
                  <font-awesome-icon style="color:#d0021b; margin-right:6px;  cursor:pointer"
                                     :icon="['fas', 'minus-circle']" />
                </span>
                <span @click="addnode()">
                  <font-awesome-icon style="color:#39B54A; margin-right:10px; cursor:pointer"
                                     :icon="['fas', 'plus-circle']" />
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--名片申请表表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="名片申请表"
               v-if="applyFormShow==3"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-date-picker v-model="applyForm.templateContent.createTime"
                              type="date"
                              placeholder="选择日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请数量">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.count"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="中文名">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.chineseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="英文名">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.englishName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="职位中文">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位英文">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.englishDutyName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="部门中文">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门英文">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.englishDepartmentName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="直线电话">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.telephone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总机及分机电话">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.zongji"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.fax"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="手机">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="e-mail">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="网址">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.website"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.remark"></el-input>
          </el-form-item>
        </el-row>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--出差报告表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="出差报告"
               v-if="applyFormShow==7"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="呈送人">
              <el-select v-model="applyForm.templateContent.postPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in allUser"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抄送">
              <el-select v-model="applyForm.templateContent.copytoPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in departmentList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="发件人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出差日期">
              <el-date-picker v-model="applyForm.templateContent.startTime"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="出差地点">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.place"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="出差期间主要拜访人员">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.seePeople"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="工作内容及工作成效">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.content"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="下一步工作思路及拓展方向">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.nextGoal"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="需要解决的问题、支持及建议">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--工作周报表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="工作周报"
               v-if="applyFormShow==8"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="呈送人">
              <el-select v-model="applyForm.templateContent.postPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in allUser"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抄送">
              <el-select v-model="applyForm.templateContent.copytoPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in departmentList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="发件人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期">
              <el-date-picker placeholder="选择日期"
                              v-model="applyForm.templateContent.time"
                              type="date"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="凤凰卫视中文台、资讯台、电影台市场拓展">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.fenghuangweishi"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="凤凰专区项目进展">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.fenghuangzhuanqv"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="新业务拓展">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.netTask"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="与凤凰其他部门的合作及支持">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.hezuo"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="管理中心交办事务">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.center"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="行业动态及建议">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.suggest"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--呈批件表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="呈批件"
               v-if="applyFormShow==9"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="呈送人">
              <el-select v-model="applyForm.templateContent.postPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in allUser"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抄送">
              <el-select v-model="applyForm.templateContent.copytoPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in departmentList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="发件人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期">
              <el-date-picker placeholder="选择日期"
                              v-model="applyForm.templateContent.createTime"
                              type="date"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="题目">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.topic"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="内容">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.content"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--备忘录表单-->
    <el-dialog :close-on-click-modal="false" width="500px"
               @close="applyFormShow = ''"
               class="apply-dialog"
               title="备忘录"
               v-if="applyFormShow==10"
               :visible="true">
      <el-form label-position="top"
               class="apply-form">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="标题">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="呈送人">
              <el-select v-model="applyForm.templateContent.postPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in allUser"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抄送">
              <el-select v-model="applyForm.templateContent.copytoPeople"
                         placeholder="请选择">
                <el-option v-for="(item,index) in departmentList"
                           :key="item.id"
                           :label="item.name"
                           :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="发件人">
              <el-input clearable
                        placeholder="请输入"
                        disabled
                        v-model="applyForm.templateContent.peopleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期">
              <el-date-picker placeholder="选择日期"
                              v-model="applyForm.templateContent.createTime"
                              type="date"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="题目">
              <el-input clearable
                        placeholder="请输入"
                        v-model="applyForm.templateContent.topic"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="内容">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="请输入内容"
                      v-model="applyForm.templateContent.content"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="applyFormShow=''">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import pageTitle from '@/components/pageTitle'
import getPdf from '@/utils/htmlToPdf.js'
import moment from 'moment'
export default {
  components: {
    breadcrumb,
    pageTitle
  },
  data() {
    return {
      departList: [],
      allUser: [],

      applyList: [],
      templateList: [],
      params: {
        current: 1,
        pageSize: 10,
        name: '',
        status: ''
      },
      total: 0,

      applyFormShow: '',
      applyForm: {},

      formShow: '',
      detail: {},
      templateContent: {},
      signList: {},

      dialogLoading:false
    }
  },
  created() {
    this.getList()
    this.getTemplate()
    this.initList()
  },
  filters: {
    leaveTypeFilter(v) {
      switch (v) {
        case 1:
          return '病假'
        case 2:
          return '事假'
        case 3:
          return '产假/陪产假'
        case 4:
          return '婚假'
        case 5:
          return '丧假'
      }
    }
  },
  methods: {
    initList() {
      //获取部门列表
      axios
        .get(api.departList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取部门列表成功', res.data.result)
            this.departmentList = res.data.result
          } else {
            console.log('获取部门列表失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取部门列表失败', error)
        })
      //获取所有用户
      axios
        .get(api.getAllUser)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取所有用户成功', res.data.result)
            this.allUser = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    getList() {
      axios
        .post(api.myApplyList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取申请列表成功', res.data.result)
            this.applyList = res.data.result.records
            this.total = res.data.result.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //获取模板
    getTemplate() {
      axios
        .get(api.templateAll)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取模板列表成功', res.data.result)
            this.templateList = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //添加申请弹框
    showDialog(index) {
      let id = this.templateList[index].id
      let templateContent = JSON.parse(this.templateList[index].templateContent)
      console.log(templateContent)
      this.applyForm = {
        applyPeopleName: this.$store.state.userInfo.user.name,
        copyTo: '',
        createUserId: this.$store.state.userInfo.user.id,
        fileUrlOriginal: '',
        name: '',
        postUserid: '',
        processId: this.templateList[index].processId,
        templateContent: '',
        templateId: this.templateList[index].id,
        templateName: this.templateList[index].name,
        type: this.templateList[index].type
      }
      if (id === 1) {
        this.applyForm.templateContent = {
          activities: [{ name: '', duty: '', neipei: '', neipeiDuty: '' }],
          createTime: moment().format('YYYY-MM-DD'),
          department: this.$store.state.userInfo.user.departmentName,
          duty: this.$store.state.userInfo.user.postJobName,
          money: '',
          signList: [],
          peopleName: this.$store.state.userInfo.user.name,
          peopleNum: '',
          remark: '',
          title: '',
          yingchouPlace: '',
          yingchouPurpose: '',
          yingchouTime: '',
          yingchouUnit: ''
        }
      } else if (id === 2) {
        this.applyForm.templateContent = {
          createTime: moment().format('YYYY-MM-DD'),
          department: this.$store.state.userInfo.user.departmentName,
          duty: this.$store.state.userInfo.user.postJobName,
          officeSupplies: [
            { costCenter: '', count: '', name: '', specification: '' }
          ],
          peopleName: this.$store.state.userInfo.user.name,
          remark: '',
          title: ''
        }
      } else if (id === 3) {
        this.applyForm.templateContent = {
          chineseName: this.$store.state.userInfo.user.name,
          createTime: moment().format('YYYY-MM-DD'),
          department: this.$store.state.userInfo.user.departmentName,
          duty: this.$store.state.userInfo.user.postJobName,
          email: '',
          englishDepartmentName: '',
          englishDutyName: '',
          englishName: '',
          fax: '',
          peopleName: this.$store.state.userInfo.user.name,
          phone: '',
          remark: '',
          telephone: '',
          title: '',
          website: '',
          zongji: '',
          count: ''
        }
      } else if (id === 4 || id === 5) {
        this.applyForm.templateContent = {
          createTime: moment().format('YYYY-MM-DD'),
          department: this.$store.state.userInfo.user.departmentName,
          duty: this.$store.state.userInfo.user.postJobName,
          giftList: [
            {
              giftName: '',
              count: '',
              money: '',
              guestCompany: '',
              guestDuty: '',
              guestName: ''
            }
          ],
          peopleName: this.$store.state.userInfo.user.name,
          remark: '',
          title: ''
        }
      } else if (id === 6) {
        this.applyForm.templateContent = {
          title: '',
          peopleName: this.$store.state.userInfo.user.name,
          department: this.$store.state.userInfo.user.departmentName,
          leaveType: '',
          startTime: '',
          endTime: '',
          LeaveDays: '',
          remark: '',
          annualDays: '',
          annualRemainDays: '',
          annualStartLeaveTime: '',
          annualEndLeaveTime: ''
        }
      } else if (id === 7) {
        this.applyForm.templateContent = {
          content: '',
          copytoPeople: '',
          endTime: '',
          nextGoal: '',
          peopleName: this.$store.state.userInfo.user.name,
          place: '',
          postPeople: '',
          remark: '',
          seePeople: '',
          startTime: '',
          title: ''
        }
      } else if (id === 8) {
        this.applyForm.templateContent = {
          center: '',
          copytoPeople: '',
          fenghuangweishi: '',
          fenghuangzhuanqv: '',
          hezuo: '',
          newTask: '',
          pageNum: '',
          peopleName: this.$store.state.userInfo.user.name,
          postPeople: '',
          remark: '',
          suggest: '',
          time: moment().format('YYYY-MM-DD'),
          title: ''
        }
      } else if (id === 9 || id === 10) {
        this.applyForm.templateContent = {
          content: '',
          copytoPeople: '',
          createTime: moment().format('YYYY-MM-DD'),
          peopleName: this.$store.state.userInfo.user.name,
          pishi: '',
          postPeople: '',
          title: '',
          topic: ''
        }
      }
      this.applyFormShow = id
    },
    //点击提交申请按钮
    submitApply() {
      this.dialogLoading = true
      this.applyFormShow = ''
      this.applyForm.name = this.applyForm.templateContent.title
      if (this.applyForm.templateId === 7) {
        this.applyForm.templateContent.endTime = this.applyForm.templateContent.startTime[1]
        this.applyForm.templateContent.startTime = this.applyForm.templateContent.startTime[0]
        this.applyForm.postUserid = this.allUser[
          this.applyForm.templateContent.postPeople
        ].id
        this.applyForm.templateContent.postPeople = this.allUser[
          this.applyForm.templateContent.postPeople
        ].name
        this.applyForm.copyTo = this.allUser[
          this.applyForm.templateContent.copytoPeople
        ].id
        this.applyForm.templateContent.copytoPeople = this.departmentList[
          this.applyForm.templateContent.copytoPeople
        ].name
      } else if (
        this.applyForm.templateId === 8 ||
        this.applyForm.templateId === 9 ||
        this.applyForm.templateId === 10
      ) {
        this.applyForm.postUserid = this.allUser[
          this.applyForm.templateContent.postPeople
        ].id
        this.applyForm.templateContent.postPeople = this.allUser[
          this.applyForm.templateContent.postPeople
        ].name
        this.applyForm.copyTo = this.allUser[
          this.applyForm.templateContent.copytoPeople
        ].id
        this.applyForm.templateContent.copytoPeople = this.departmentList[
          this.applyForm.templateContent.copytoPeople
        ].name
      } else if (this.applyForm.templateId === 6) {
        this.applyForm.templateContent.endTime = this.applyForm.templateContent.startTime[1]
        this.applyForm.templateContent.startTime = this.applyForm.templateContent.startTime[0]
        this.applyForm.templateContent.annualEndLeaveTime = this.applyForm.templateContent.annualStartLeaveTime[1]
        this.applyForm.templateContent.annualStartLeaveTime = this.applyForm.templateContent.annualStartLeaveTime[0]
      }
      this.templateContent = this.applyForm.templateContent
      this.signList = [
        {
          signUrl: this.$store.state.userInfo.user.personalSignatureUrl,
          date: moment().format('YYYY-MM-DD hh:mm:ss')
        }
      ]
      this.detail.nodeUserIdsList = []
      this.detail.name = this.applyForm.name
      this.formShow = this.applyForm.templateId
      this.dialogLoading = false
      setTimeout(() => {
        this.createdPdf(this.formShow)
      }, 100)
    },
    //显示详情
    showDetail(id) {
      axios
        .get(api.applyDetail + '/' + id)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取审批详情成功', res.data.result)
            this.detail = res.data.result
            this.templateContent = JSON.parse(res.data.result.templateContent)
            this.signList = JSON.parse(res.data.result.signList) || []
            this.formShow = res.data.result.templateId
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    createdPdf(id) {
      let element = document.createElement('div')
      let template = document.getElementById(`template${id}`)
      element.style = 'z-index:-100;position:fixed;width:800px;top:100%;'
      element.className = 'el-dialog'
      element.appendChild(
        template.getElementsByClassName('el-dialog__header')[0].cloneNode(true)
      )
      element.appendChild(
        template.getElementsByClassName('el-dialog__body')[0].cloneNode(true)
      )
      template.appendChild(element)
      getPdf(this.detail.name, element).then(res => {
        template.removeChild(element)
        this.uploadPdf(res)
      })
    },
    //上传pdf
    uploadPdf(pdf) {
      let param = new FormData()
      param.append('file', pdf, pdf.name)
      param.append('fileType', 3)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      axios
        .post(api.uploadFile, param, config)
        .then(res => {
          if (res.data.code === 0) {
            console.log('上传申请PDF成功', res.data.result)
            this.applyForm.fileUrlOriginal = res.data.result[0]
            this.applyForm.templateContent = JSON.stringify(
              this.applyForm.templateContent
            )
            this.applyForm.signList = JSON.stringify(this.signList)
            this.addApply()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //提交表单
    addApply() {
      axios
        .post(api.addApply, this.applyForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '提交申请成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    addnode() {
      let id = this.applyForm.templateId
      if (id === 1) {
        this.applyForm.templateContent.activities.push({
          name: '',
          duty: '',
          neipei: '',
          neipeiDuty: ''
        })
      } else if (id === 2) {
        this.applyForm.templateContent.officeSupplies.push({
          name: '',
          duty: '',
          neipei: '',
          neipeiDuty: ''
        })
      } else if (id === 4 || id === 5) {
        this.applyForm.templateContent.giftList.push({
          giftName: '',
          count: '',
          money: '',
          guestCompany: '',
          guestDuty: '',
          guestName: ''
        })
      }
    },
    delnode() {
      let id = this.applyForm.templateId
      if (id === 1) {
        if (this.applyForm.templateContent.activities.length === 1) {
          this.$message.error('不能再减少了')
          return
        }
        this.applyForm.templateContent.activities.pop()
      } else if (id === 2) {
        if (this.applyForm.templateContent.officeSupplies.length === 1) {
          this.$message.error('不能再减少了')
          return
        }
        this.applyForm.templateContent.officeSupplies.pop()
      } else if (id === 4 || id === 5) {
        if (this.applyForm.templateContent.giftList.length === 1) {
          this.$message.error('不能再减少了')
          return
        }
        this.applyForm.templateContent.giftList.pop()
      }
    },
    changePage(v) {
      this.params.current = v
      this.getList()
    }
  }
}
</script>

<style lang="scss">
.apply {
  .apply-wrap {
    padding: 77px 30px 0px 30px;
    .apply-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .apply-table-wrap {
        padding: 30px;
        .apply-table {
          min-height: 470px;
          tr {
            height: 47px;
            td {
              padding: 0px 19px;
              &:first-child {
                cursor: pointer;
                &:hover {
                  color: #f0722b;
                }
              }
              div {
                display: inline-block;
              }
            }
          }
        }
        .apply-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .apply-dialog {
    .apply-icon {
      position: absolute;
      bottom: 32px;
    }
    .apply-dialog_title {
      font-size: 18px;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      line-height: 18px;
      border-left: 4px #f0722b solid;
      padding-left: 10px;
      span {
        position: relative;
        top: 1px;
      }
    }
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;

    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: center;
      .el-button {
        width: 88px;
      }
    }
    .apply-form {
      .apply-title {
        margin-bottom: 20px;
        color: #4a4a4a;
        font-weight: 600;
        font-size: 18px;
      }

      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .apply-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
  .template_dialog {
    .template_dialog-title {
      font-size: 26px;
      justify-content:center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .tempalte_dialog-title_img{
        width:50px;
        height: 50px;
        margin-right: 10px;

      }
    }
    .el-row {
      display: flex;
    }
    .template_col {
      display: flex;
      &:last-child {
        border-right: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .dialog-footer {
      text-align: center;
    }
    .template_dialog-item,
    .template_dialog-item_title,
    .template_dialog-item_gray,
    .template_dialog-item_question,
    .template_dialog-item_input,
    .template_dialog-item_img {
      white-space: pre-line;
      font-size: 16px;
      min-height: 44px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
      text-align: center;
      border-bottom: 0px;
      width: 100%;
      word-break: break-all;
      overflow-wrap: break-word;
      &.last {
        border-bottom: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .left{
      justify-content: flex-start;

    }
    .template_dialog-item_img {
      padding: 0px;
      flex: 1;
      img {
        height: 44px;
        object-fit: contain;
      }
    }
    .template_dialog-item_input {
      flex: 1;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
      .template_dialog-item_text {
        flex: 1;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .template_dialog-item_sign {
        align-self: flex-end;
        display: flex;
        height: 60px;
        text-align: left;
        img {
          width: 150px;
          height: 50px;
        }
      }
    }
    .template_dialog-process {
      height: 180px;
      font-size: 16px;
      flex: 1;
      line-height: 180px;
      text-align: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
    }
    .template_dialog-item {
      flex: 1;
    }
    .template_dialog-item_question {
      width: 300px;
      min-height: 100px;
    }
    .template_dialog-item_title {
      width: 110px;
    }
    .template_dialog-item_gray {
      background: #fafafa;
      flex: 1;
    }
  }
}
</style>
